import autosize from 'autosize'

  autosize(document.querySelectorAll('textarea'));